<div class="profile-authentication-area ptb-70 auth-center">
  <div class="container">
    <div class="row justify-content-center align-items-center min-vh-100">
      <div class="col-lg-6 col-md-8 col-sm-12">
        <div class="login-form animate_animated animate_fadeIn">
          <h2>
            {{ idioma | translate : "login.RECUPERAR-CONTRASENA" | async }}
          </h2>
          <form [formGroup]="form" (ngSubmit)="resetPassword()">
            <div class="form-group">
              <label>Email</label>
              <input
                formControlName="email"
                type="email"
                class="form-control text-lowercase"
                placeholder="Ingrese su email para recuperar la contraseña"
                [class.is-invalid]="emailNoValido"
              />
              <small *ngIf="emailNoValido" class="text-danger">{{
                idioma | translate : "form.EMAIL-INVALIDO" | async
              }}</small>
            </div>
            <div class="form-group">
              <ngx-recaptcha2
                #captchaElem
                [siteKey]="siteKey"
                formControlName="recaptcha"
              >
              </ngx-recaptcha2>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <button [disabled]="!form.valid" type="submit" disabled>
                  Recuperar
                </button>
              </div>
              <div class="col-lg-6">
                <button
                  class="btn btn-warning"
                  type="button"
                  [routerLink]="['/login']"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
